import React, { useState } from "react"
import { formatFocusedImage } from "../formatBaseMolecules"
import renderPaddingOrFullBleed from "../renderPaddingOrFullBleed"
import formatPageLinks from "../formatPageLinks"
import formatVideo from "../formatVideo"
import { PullQuote } from "terra-one"
import formatLottieAnimation from "../formatLottieAnimation"
import { formatPullQuote } from "../FormatPullQuote"

const FormatAndRenderPullQuote = props => {
  const [override, setOverride] = useState(false)
  const { data = {}, i, locale, products, siteIdentifier } = props

  const quoteContent = formatPullQuote(
    data,
    locale,
    props,
    products,
    siteIdentifier
  )

  const nestedInTab = data?.nestedInTab
  const linkType = quoteContent?.cta?.url?.contentType
    ? quoteContent?.cta?.url?.contentType
    : quoteContent?.cta?.url?.internal?.type
    ? quoteContent?.cta?.url?.internal?.type
    : null

  const cta = formatPageLinks(
    quoteContent?.cta,
    locale,
    linkType,
    null,
    props?.currentSpaceId,
    products,
    siteIdentifier
  )

  if (cta?.video) {
    cta.video = formatVideo(cta.video)
    cta["override"] = override
    cta["setOverride"] = setOverride
  }

  const isTopImage = quoteContent?.topImage?.focalPointImage?.url

  const variant = () => {
    if (isTopImage) {
      return "variant3"
    } else if (quoteContent?.imageOptions === "1/2") {
      return "variant2"
    } else if (quoteContent?.imageOptions === "1/4") {
      if (quoteContent?.appearance === "Light") {
        return "variant1"
      }
      if (quoteContent?.appearance === "Dark") {
        return "variant2"
      }
    } else if (quoteContent?.imageOptions === "No Image") {
      if (quoteContent?.appearance === "Light") {
        return "variant1"
      }
      if (quoteContent?.appearance === "Dark") {
        return "variant2"
      }
    } else {
      return ""
    }
  }

  const padding = true,
    fullBleedColor = false,
    inheritBackground = false

  return renderPaddingOrFullBleed(
    <PullQuote
      content={quoteContent}
      variant={variant()}
      key={i}
      nestedInTab={nestedInTab}
    />,
    padding,
    fullBleedColor,
    inheritBackground
  )
}

export default FormatAndRenderPullQuote

export const formatPullQuoteImage = (image, styles) => {
  return image?.__typename === "ContentfulLottieAnimation"
    ? formatLottieAnimation(image?.json || image?.srcLink, styles)
    : formatFocusedImage(image)
}
